export default __webpack_public_path__ + "static/certificate-relay-vertical-8c40676a095496315789e1ffa6a0d93b.png";